<template>
  <div style="height: 100%;width: 100%">
    <div style="height: 10px"></div>
    <div style="margin: 0 40px">
      <!--        <div style="height: 20px"></div>-->
      <el-row style="text-align: center;font-size: 14px;color: white">
        <el-col :span="8">
          <span>服务总数</span>
        </el-col>
        <el-col :span="8">
          <span>接警总数</span>
        </el-col>
        <el-col :span="8">
          <span>呼入总数</span>
        </el-col>
      </el-row>
      <el-row style="font-family: letisgoDigital;font-size: 24px">
        <el-col :span="8">
          <div class="list-top1">
            <span>{{servicescount}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list-top2">
            <span>{{alarmcount}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list-top3">
            <span>{{phoneincount}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 10px"></div>
    <div style="margin: 0 40px">
      <el-row style="text-align: center;font-size: 14px;color: white">
        <el-col :span="8">
          <span>回访总数</span>
        </el-col>
        <el-col :span="8">
          <span>咨询总数</span>
        </el-col>
        <el-col :span="8">
          <span>外访总数</span>
        </el-col>
      </el-row>
      <el-row style="font-family: letisgoDigital;font-size: 24px">
        <el-col :span="8">
          <div class="list-top5">
            <span>{{phonecallcount }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list-top6">
            <span>{{lawerservicecount}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list-top4">
            <span>{{carecount}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'centerTopList',
  data () {
    return {
      servicescount: 0,
      alarmcount: 0,
      phoneincount: 0,
      carecount: 0,
      phonecallcount: 0,
      lawerservicecount: 0
    }
  },
  created () {
    this.golobleObject.getMqttAddCnt = this.addCnt
  },
  methods: {
    getAlarmCount (topObj) {
      this.servicescount = topObj.dataviewcount.servicescount
      this.alarmcount = topObj.dataviewcount.alarmcount
      this.phoneincount = topObj.dataviewcount.phoneincount
      this.carecount = topObj.dataviewcount.carecount
      this.phonecallcount = topObj.dataviewcount.phonecallcount
      this.lawerservicecount = topObj.dataviewcount.lawerservicecount
    },
    addCnt (obj) {
      // console.log('top', 111)
      this.alarmcount += 1
      if (obj.alarmtype === 'phonein') {
        this.phoneincount += 1
      }
    }
  }
}
</script>

<style scoped>
.list-top1{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_center_up_1.png");
  background-size: 100% 100%;
  color: #ff9159;
}
.list-top2{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_center_up_2.png");
  background-size: 100% 100%;
  color: #59ffff;
}
.list-top3{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_center_up_3.png");
  background-size: 100% 100%;
  color: #59ff59;
}
.list-top4{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_centre_up_4.png");
  background-size: 100% 100%;
  color: #59c8ff;
}
.list-top5{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_centre_up_5.png");
  background-size: 100% 100%;
  color: #ffe359;
}
.list-top6{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_centre_up_6.png");
  background-size: 100% 100%;
  color: #ff5990;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/centerTopList.vue